import { gql } from '@apollo/client/core';

export const updateLocation = gql`
  mutation updateLocation($id: ID!, $input: CreateLocationInput!) {
    updateLocation(id: $id, input: $input) {
      id
      state
      county
      township
      updater
      createdAt
      updatedAt
      deletedAt
      businessUnits {
        name
        id
      }
    }
  }
`;
